import "./style.scss";
import $ from "jquery";
import 'slick-carousel';
import "slick-carousel/slick/slick.scss";

$(function () {
    var initializeBlock = function () {
        if ($('.izpostavljene-novice-slider').length) {
            $('.izpostavljene-novice-slider').not(".slick-initialized").slick({
                slidesToShow: 4,
                infinite: true,
                dots: true,
                arrows: true,
                nextArrow: '<div class="ow-slick-arrow ow-slick-arrow--next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><mask id="mask0_2693_7316" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25"><rect y="0.5" width="24" height="24" fill="#D9D9D9"/></mask><g mask="url(#mask0_2693_7316)"><path d="M8.025 22.5L6.25 20.725L14.475 12.5L6.25 4.275L8.025 2.5L18.025 12.5L8.025 22.5Z" fill="#2F4858"/></g></svg></div>',
                prevArrow: '<div class="ow-slick-arrow ow-slick-arrow--prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><mask id="mask0_2693_7264" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25"><rect y="0.5" width="24" height="24" fill="#D9D9D9"/></mask><g mask="url(#mask0_2693_7264)"><path d="M10 22.5L0 12.5L10 2.5L11.775 4.275L3.55 12.5L11.775 20.725L10 22.5Z" fill="#2F4858"/></g></svg></div>',
                draggable: true,
                appendDots: $('.izpostavljene-novice-slider__dots'),
                responsive: [
                    {
                        breakpoint: 990,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                        }
                    }
                ]
            });

            $('.novice-card__title').each(function () {
                var $slide = $(this).closest('.novice-card');
                if ($slide.attr('aria-describedby') != undefined) { // ignore extra/cloned slides
                    $(this).attr('id', $slide.attr('aria-describedby'));
                }
            });
        }
    }

    initializeBlock();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=ow/izpostavljene-novice', initializeBlock);
    }
});